import { render, staticRenderFns } from "./LoginSetup.vue?vue&type=template&id=1166fee2&scoped=true"
import script from "./LoginSetup.vue?vue&type=script&lang=js"
export * from "./LoginSetup.vue?vue&type=script&lang=js"
import style0 from "./LoginSetup.vue?vue&type=style&index=0&id=1166fee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1166fee2",
  null
  
)

export default component.exports